import { graphqlFetch } from '../utils/graphqlFetch';

/**
 * Execute a GraphQL query/mutation, extract the result data, and throw on errors.
 *
 * Uses the existing graphqlFetch wrapper which handles auth tokens,
 * proactive refresh, and 401 retry automatically.
 *
 * @param query    - GraphQL query or mutation string
 * @param variables - Variables to pass to the operation
 * @returns The parsed `data` object from the response
 */
export async function gql<T = any>(
  query: string,
  variables?: Record<string, any>,
): Promise<T> {
  const result = await graphqlFetch(query, variables);

  if (result.errors) {
    console.error('GraphQL errors:', result.errors);
    throw new Error(result.errors[0].message);
  }

  return result.data;
}
